import React from 'react';
import { TextField, SelectInput, translate as translateHOC } from 'react-admin';
import { FormLabel, Typography } from '@material-ui/core';
import { getIsUnitInvoicesEnabled } from '../helpers/invoiceHelpers';

const StaticField = translateHOC(({ translate }) => (
  <div
    key="Selenium-businessDetails-subscription"
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    }}
  >
    <FormLabel style={{ fontSize: 12 }}>{translate('resources.business.fields.subscription')}</FormLabel>
    <Typography variant="body1" style={{ fontSize: 14 }}>
      {translate('resources.business.fields.invoiceFrequencies.monthly').toUpperCase()}
    </Typography>
  </div>
));

/**
 * Custom hook to get invoice frequency fields based on the provided context and services.
 *
 * @param {Object} params - The parameters for the hook.
 * @param {Object} params.classes - The CSS classes to apply to the fields.
 * @param {('SHOW'|'EDIT')} [params.context='SHOW'] - The context in which the fields are being used ('SHOW' or 'EDIT').
 * @param {Array} [params.invoiceFrequencyList=[]] - The list of invoice frequency choices for the SelectInput.
 * @param {Array} params.services - The list of business services.
 *
 * @returns {Array} An array of React elements representing the invoice frequency fields.
 */
const useGetInvoiceFrequencyFields = ({ classes, context = 'SHOW', invoiceFrequencyList = [] }) => {
  const showSubscriptionFrequency = getIsUnitInvoicesEnabled();

  const getInvoiceFrequencyFields = () => {
    const defaultField =
      context === 'SHOW' ? (
        <TextField
          source="invoiceFrequency"
          className={classes.groupedField}
          classes={{ root: classes.groupedFieldContent }}
          id="Selenium-businessDetails-invoiceFrequency"
          key="Selenium-businessDetails-invoiceFrequency"
        />
      ) : (
        <SelectInput
          source="invoiceFrequency"
          id="Selenium-Business-Edit-invoiceFrequency-Select"
          className={classes.fieldEdit}
          choices={invoiceFrequencyList}
          allowEmpty={false}
          key="Selenium-Business-Edit-invoiceFrequency-Select"
        />
      );
    const fields = [defaultField];

    if (showSubscriptionFrequency) fields.unshift(<StaticField key="Selenium-businessDetails-subscription" />);

    return fields;
  };

  return getInvoiceFrequencyFields();
};

export default useGetInvoiceFrequencyFields;
